
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cms/[...cmsPage]",
      function () {
        return require("private-next-pages/cms/[...cmsPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cms/[...cmsPage]"])
      });
    }
  